import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { CRMKanban } from './components/CRMKanban';

export const CRMOverview: React.FC = () => {
    const handleCreateEntry = () => {
        // TODO: Implement create entry dialog
        console.log('Create new CRM entry');
    };

    return (
        <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
            <CRMKanban onCreateEntry={handleCreateEntry} />
        </Box>
    );
}; 